import * as Analytics from 'analytics/analytics'
import { logOperational } from 'analytics/snowplow/events'
import watch from 'redux-watch'
import { AppStore } from 'src/client/store'
import {
  saveCheckoutInCartServiceWithDebounce,
  saveCheckoutReduxCartState,
  saveCheckoutReduxFormState,
  saveCheckoutReduxPaymentState,
} from 'storage/checkout'

export function watchCheckout(store: AppStore) {
  store.subscribe(
    watch(store.getState, 'checkout')(async(newState: App.CheckoutState, oldState: App.CheckoutState) => {
      if (newState.cart !== oldState.cart && !newState.cart.isAbandonedCart) {
        const appState = store.getState()
        const cart = {
          ...newState.cart,
          lastSaveTimestamp: Date.now(),
        }
        const user_id = appState.auth.account.memberId
        Analytics.track('log-operational', logOperational('watcher_checkout', `save_cart_${user_id}_${cart.transactionKey}_${cart.items.length}_items`))
        saveCheckoutReduxCartState(cart)
        saveCheckoutInCartServiceWithDebounce(appState)
      }
      if (newState.form !== oldState.form) {
        saveCheckoutReduxFormState(newState.form)
      }
      if (newState.payment !== oldState.payment) {
        if (newState.promo?.code) {
          newState.payment.promoCode = newState.promo?.code
        }
        saveCheckoutReduxPaymentState(newState.payment)
      }
    }),
  )
}
